import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { RefreshCw, X } from 'lucide-react';
import {
  guncellemeyiDinle, guncellemeyiUygula, guvenliAndaUygula, yenilemeGuvenliMi,
  yazmaIzniniSifirla,
} from '../utils/appVersion';

/**
 * ⬆️ GÜNCELLEME ŞERİDİ — "Ctrl+F5 yapın" demenin sonu
 *
 * Yeni sürüm yayınlandığında üstte ince bir şerit çıkar. Kullanıcının işi
 * KESİLMEZ: ne sayım başlar, ne oturum kapanır, ne sayfa zorla yenilenir.
 *
 * Güncelleme iki yoldan uygulanır:
 *   · Kullanıcı "Şimdi güncelle"ye basarsa — hemen (güvenliyse)
 *   · Basmazsa SAYFA DEĞİŞTİRİRKEN kendiliğinden. Sayfa değişimi doğal bir
 *     aradır: kullanıcı fişini kaydedip başka ekrana geçmiştir, kaybolacak
 *     yarım iş yoktur.
 *
 * Ekranda doldurulmuş form, açık modal ya da süren bir kayıt varsa uygulama
 * ERTELENİR ve şerit "işiniz bitince uygulanacak" der — veri kaybı olmaz.
 */
// Müşterinin tek seferlik girdiği token'lı sayfalar. Burada ne şerit gösterilir
// ne de otomatik yenileme yapılır: müşteri "yeni sürüm" ile ilgilenmez, formu
// doldurup çıkar. Yarım formu yenilemek en kötü sonuç olurdu.
const PUBLIC_YOLLAR = ['/iade/', '/takip/', '/aktivasyon/', '/odeme-sonuc'];

export default function GuncellemeSeridi() {
  const [bekleyen, setBekleyen] = useState(null);
  const [gizli, setGizli] = useState(false);
  const [uyari, setUyari] = useState(false);
  const yer = useLocation();

  useEffect(() => guncellemeyiDinle(setBekleyen), []);

  const publicSayfa = PUBLIC_YOLLAR.some((p) => yer.pathname.startsWith(p));

  // GERÇEK sayfa değişiminde uygula — ilk açılışta DEĞİL.
  //
  // useEffect ilk montajda da çalışır; sadece [pathname]'e bakmak "sayfaya
  // girer girmez kendini yenile" demek olurdu. Kullanıcı şeridi görmeden
  // sayfa yenileniyordu (tarayıcı testinde yakalandı). Önceki yolu tutup
  // yalnız gerçekten değiştiğinde uyguluyoruz.
  const oncekiYol = useRef(yer.pathname);
  useEffect(() => {
    const degisti = oncekiYol.current !== yer.pathname;
    oncekiYol.current = yer.pathname;
    if (!degisti) return undefined;
    // Sayfa değişti → önceki ekranda yazılanlar artık geçerli değil (kullanıcı
    // kaydedip geçti ya da bıraktı). Yazma izini temizle ki güncelleme
    // sonsuza kadar ertelenmesin.
    yazmaIzniniSifirla();
    if (!bekleyen || publicSayfa) return undefined;
    // Kısa gecikme: yeni sayfa monte olsun, eskisinin alanları DOM'dan çıksın —
    // yoksa ayrıldığımız formu "dolu" sanıp güncellemeyi boşuna erteleriz.
    const t = setTimeout(() => { guvenliAndaUygula(); }, 400);
    return () => clearTimeout(t);
  }, [yer.pathname, bekleyen, publicSayfa]);

  if (!bekleyen || gizli || publicSayfa) return null;

  const simdi = () => {
    if (yenilemeGuvenliMi()) { guncellemeyiUygula(); return; }
    setUyari(true);
    setTimeout(() => setUyari(false), 6000);
  };

  return (
    <div style={{
      position: 'sticky', top: 0, zIndex: 9999,
      display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap',
      padding: '7px 14px', background: '#0f172a', color: '#fff',
      fontSize: 13, lineHeight: 1.4,
      fontFamily: '-apple-system, "Segoe UI", Roboto, Arial, sans-serif',
    }}>
      <RefreshCw size={14} style={{ flexShrink: 0 }} />
      <span style={{ flex: '1 1 240px', minWidth: 0 }}>
        <b>Yeni sürüm hazır.</b>{' '}
        {uyari
          ? <span style={{ color: '#fcd34d' }}>
              Ekranda kaydedilmemiş bilgi var. Kaydedip başka bir sayfaya
              geçtiğinizde kendiliğinden uygulanacak.
            </span>
          : <span style={{ opacity: 0.8 }}>
              Sayfa değiştirdiğinizde kendiliğinden uygulanır; işinizi
              kaybetmezsiniz.
            </span>}
      </span>
      <button onClick={simdi} style={{
        flexShrink: 0, padding: '5px 12px', borderRadius: 7, border: 0,
        background: '#fff', color: '#0f172a', fontWeight: 700, fontSize: 12,
        cursor: 'pointer',
      }}>
        Şimdi güncelle
      </button>
      <button onClick={() => setGizli(true)} title="Şeridi gizle (güncelleme yine de uygulanır)"
        style={{
          flexShrink: 0, padding: 4, borderRadius: 6, border: 0,
          background: 'transparent', color: '#94a3b8', cursor: 'pointer',
          display: 'flex', alignItems: 'center',
        }}>
        <X size={14} />
      </button>
    </div>
  );
}
